class FormatHelper {
    static getFormatted2DecimalNumber(numberToFormat: number): number {
        return (Math.round(numberToFormat * 100)) / 100;
    }
}

export default FormatHelper;
